import { render } from "./PhotoStats.vue?vue&type=template&id=c2cd581a"
import script from "./PhotoStats.vue?vue&type=script&lang=js"
export * from "./PhotoStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__